import { createSlice } from "@reduxjs/toolkit";
import { userManagementInitialState } from "../initialState";

const userManagementSlice = createSlice({
  name: "userManagement",
  initialState: userManagementInitialState,
  reducers: {
    // Fetch Users List
    fetchUsersStart: function(state) {
      state.loading.list = true;
      state.errors.list = null;
    },
    fetchUsersSuccess: function(state, action) {
      state.users = action.payload.userList;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      state.loading.list = false;
    },
    fetchUsersFail: function(state, action) {
      state.loading.list = false;
      state.errors.list = action.payload;
    },

    // Create User
    createUserStart: function(state) {
      state.loading.create = true;
      state.errors.create = null;
      state.createResult = null;
    },
    createUserSuccess: function(state, action) {
      state.loading.create = false;
      state.createResult = action.payload;
    },
    createUserFail: function(state, action) {
      state.loading.create = false;
      state.errors.create = action.payload;
    },
    clearCreateResult: function(state) {
      state.createResult = null;
      state.errors.create = null;
    },

    // Update User
    updateUserStart: function(state) {
      state.loading.update = true;
      state.errors.update = null;
    },
    updateUserSuccess: function(state, action) {
      state.loading.update = false;
      // Update user in list if exists
      const index = state.users.findIndex(function(u) {
        return u.userId === action.payload.userId;
      });
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...action.payload };
      }
    },
    updateUserFail: function(state, action) {
      state.loading.update = false;
      state.errors.update = action.payload;
    },

    // Fetch Parent Share
    fetchParentShareStart: function(state) {
      state.loading.parentShare = true;
      state.errors.parentShare = null;
    },
    fetchParentShareSuccess: function(state, action) {
      state.loading.parentShare = false;
      state.parentShare = action.payload;
    },
    fetchParentShareFail: function(state, action) {
      state.loading.parentShare = false;
      state.errors.parentShare = action.payload;
    },
    clearParentShare: function(state) {
      state.parentShare = null;
    },

    // User Actions (deposit, withdraw, block, etc.)
    userActionStart: function(state) {
      state.loading.action = true;
      state.errors.action = null;
    },
    userActionSuccess: function(state, action) {
      state.loading.action = false;
      // Update user in list
      const index = state.users.findIndex(function(u) {
        return u.userId === action.payload.userId;
      });
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...action.payload.updates };
      }
    },
    userActionFail: function(state, action) {
      state.loading.action = false;
      state.errors.action = action.payload;
    },

    // Set Selected User
    setSelectedUser: function(state, action) {
      state.selectedUser = action.payload;
    },
    clearSelectedUser: function(state) {
      state.selectedUser = null;
    },

    // Reset
    resetUserManagement: function(state) {
      return userManagementInitialState;
    },
  },
});

export default userManagementSlice.reducer;
export const userManagementActions = userManagementSlice.actions;